import React from "react"
import PhoneMain from "@ecom/ui/components/PhoneMain"
import Container from "@ecom/ui/components/Container"
import { AppLink } from "@ecom/ui/components/AppLink"
import * as styles from "./footerProducts.module.scss"

interface FooterProps {
  phones?: string
  children?: any
}

export function FooterProducts({ phones = "8 (800) 100-77-72", children }: FooterProps) {
  return (
    <footer className={styles.productfooter}>
      <Container>
        <div className={styles.block}>
          <div className={styles.sites}>
            <AppLink href="https://sovcombank.ru/" target="_blank" rel="noreferrer">
              sovcombank.ru
            </AppLink>
            <AppLink href="https://halvacard.ru/" target="_blank" rel="noreferrer">
              halvacard.ru
            </AppLink>
            <AppLink href="https://halvacard.ru/order/card-mir/" target="_blank" rel="noreferrer">
              Оформить карту “Халва”
            </AppLink>
          </div>
          <div className={styles.phone}>
            <PhoneMain phone={phones} />
          </div>
        </div>
        <div className={styles.ligal}>{children}</div>
      </Container>
    </footer>
  )
}
